 import $ from 'jquery'
 import moment from 'moment'

 $ ->
  # Defaults
  $.datepicker.setDefaults
    regional: I18n.locale
    dateFormat: "dd-mm-yyyy"

  $("input.datepicker").datepicker
    format: "dd-mm-yyyy"
    language: I18n.locale

  moment.locale(I18n.locale)

  $("[data-toggle='popover']").popover(position: 'top')
  $('[data-toggle="tooltip"]').tooltip()

  $('.toggle-search').click (e) ->
    e.preventDefault()
    $('.search').toggle()

  $('.nested-fields-table').on 'cocoon:after-insert', () ->
    $('.select2_collection select').each ->
      new KCVS.Select2CollectionInput(this)

  $('.other-parties').on 'cocoon:before-insert', (e, insertedItem, originalEvent) ->
    $input = $(insertedItem).find("select.select2_remote_collection")
    $input.data('options', {"tags": true})

    $input.on 'select2:select', (e, _l, _e) ->
      data = e.params.data
      $input = $(e.target)
      console.log($input)
      $input.closest("tr").find(".registration_number").val(data.registration_number)
      $input.closest("tr").find(".bank_account").val(data.bank_account)

    $input.on 'select2:unselect', (e, _l, _e) ->
      $input = $(e.target)

      $input.closest("tr").find(".registration_number").val("")
      $input.closest("tr").find(".bank_account").val("")

    new KCVS.Select2RemoteCollectionInput($(insertedItem).find("select.select2_remote_collection"))

  # pagination
  # TODO: make pagination autoload (fix scrolling triggers)
  # if $('.pagination').size() > 0
  #   $(".layout-content").on 'scroll', ->
  #     more_posts_url = $('.pagination a.next_page').attr('href')
  #     console.log("current element: #{$('.layout-content').height()}")
  #     console.log("document: #{$('.container-fluid').height()}")
  #     console.log("window: #{$(window).height()}")
  #     if more_posts_url && $(window).scrollTop() > $(document).height() - $(@).height() - 60
  #       $.ajax
  #         url: more_posts_url
  #         beforeSend: ->
  #           $('body').append("<div class='loading'></div>")
  #           $('.pagination').html("")
  #         success: (data, response) ->
  #           $('body').remove(".loading")
  #           $('tbody').append(data)
